module.exports = __webpack_public_path__ + "img/title.be8b9f01.png";